import Queue from './queue'
import { datePurify } from './utils'
import { isMiniApplets } from './browser'

function getApp() {   //  'EMP' 'WUC' 'ZUC'
    let businessData = {
        appSource: ''
    }
    const isMiniApp = isMiniApplets()
    // const Mapping = {
    //     alipay: 'ZUC',
    //     wechat: 'WUC',
    //     eleme: 'EMP',
    // }
    const Mapping = {
        alipay: 'alipay',
        wechat: 'wechat',
        eleme: 'eleme',
    }
    if (isMiniApp) {
        if (Mapping.hasOwnProperty(isMiniApp)) {
            businessData.appSource = Mapping[isMiniApp]
            return businessData
        }
    }
    return businessData
}

let env = {
    VUE_APP_EDITION: ''
}

/**
 * 日志记录
 */
export default class Log {

    /**
     * 单例
     * @return {?}
     */
    static getInstance() {
        if (!Log.instance) {
            Log.instance = new Log()
        }
        return Log.instance
    }

    static instance
    u

    constructor() {
        this.u = navigator.userAgent
    }

    /**
     * uuid 设置
     * @return {?} 
     */
    setUuid() {
        let uuid = sessionStorage.getItem('hdbUuid')
        if (!uuid) {
            uuid = this.generateUUID()
            sessionStorage.setItem('hdbUuid', uuid)
        }
        return uuid
    }

    /**
     * 生成uuid
     * @return {?}
     */
    generateUUID() {
        let uuid = ''
        let d = new Date().getTime()
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return uuid
    }

    /**
     * 发送请求
     * @param data 
     */
    senLog(data) {
        try {
            let useData = JSON.parse(JSON.stringify(Object.assign(this.commonaAppData(), data)))
            useData.referPointID = sessionStorage.getItem('hdbReferPointID') || useData.pointID
            let appSource = getApp() // 全局获取 app Source函数
            useData.businessData = Object.assign(appSource, useData.businessData)
            Queue.getInstance().pushToQueue(useData)
            if (useData.pointID) {
                sessionStorage.setItem('hdbReferPointID', useData.pointID)
            }
        } catch (e) {
            console.log('打点报错')
        }
    }

    /**
     * 返回通用字段
     * @return {?}
     */
    commonaAppData() {
        let data = {
            platform: `活动H5`,
            version: env.VUE_APP_EDITION || '', // H5版本号
            platformVersion: '', // 平台版本
            app: 'HDB',
            brand: '', // 手机品牌
            model: '', // 手机型号
            system: '', // 手机操作系统
            userID: localStorage.getItem('userId') || "", // userId
            openID: localStorage.getItem('openId') || "", // 用户openId
            scene: '', // 进入小程序场景值
            sessionID: sessionStorage.getItem('hdbUuid') || "", // 会话唯一标识
            latitude: sessionStorage.getItem('hdbLatitude') || "", // 用户纬度
            longitude: sessionStorage.getItem('hdbLongitude') || "", // 用户经度
            deviceID: '', // 设备ID
            shopID: '', // 门店ID
            UA: this.u, // 浏览器信息
            pointID: '', // 点位ID
            referPointID: '', // 上次打点点位ID
            errorMsg: '', // 报错信息
            eventType: '', // 事件类型
            businessData: {}, // 扩展字段
            enNewUser: localStorage.getItem('enNewUser') || '0', // 是否新用户
            pointX: 0, // 横坐标
            pointY: 0, // 纵坐标
            userSystemTime: datePurify(new Date()), // 用户系统时间

        }
        return JSON.parse(JSON.stringify(data))
    }


}

